import { render, staticRenderFns } from "./TemplateRender.vue?vue&type=template&id=78ccfe30&scoped=true"
import script from "./TemplateRender.vue?vue&type=script&lang=js"
export * from "./TemplateRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ccfe30",
  null
  
)

export default component.exports